import { render, staticRenderFns } from "./MessageTab.vue?vue&type=template&id=b48dd47c&scoped=true&"
import script from "./MessageTab.vue?vue&type=script&lang=ts&"
export * from "./MessageTab.vue?vue&type=script&lang=ts&"
import style0 from "./MessageTab.vue?vue&type=style&index=0&id=b48dd47c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48dd47c",
  null
  
)

export default component.exports